import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  NotificationImportant,
} from "@mui/icons-material";
import { isEmpty, isArray } from "lodash";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import DismissibleAlert from "./DismissibleAlert";
import ActiveFinancingRequestsConditionsSection from "../../screens/DashboardHomeScreen/ActiveFinancingRequestsConditionsSection";
import { Button } from "@mui/material";
import Flx from "../layout/Flx";

const ActionRequiredAlert = () => {
  const financingRequests = useSelector((state) => state?.financingRequests);
  const [show, setShow] = useState(true);
  const [showDetails, setShowDetails] = useState(false);
  const actionRequiredInfo = useMemo(() => {
    if (isEmpty(financingRequests)) {
      return { show: false, hasUnderwriting: false, hasTermSheet: false };
    }

    let hasUnderwriting = false;
    let hasTermSheet = false;

    financingRequests.forEach((loan) => {
      // Check for underwriting requirements
      if (
        Array.isArray(loan.underwritingRequirements) &&
        loan.underwritingRequirements.length > 0
      ) {
        hasUnderwriting = true;
      }

      // Check for term sheets
      const loanDocuments = loan?.loanDocuments;
      if (isArray(loanDocuments)) {
        if (
          !isEmpty(loanDocuments.filter((doc) => doc.docType === "Term Sheet"))
        ) {
          hasTermSheet = true;
        }
      }
    });

    return {
      show: hasUnderwriting || hasTermSheet,
      hasUnderwriting,
      hasTermSheet,
    };
  }, [financingRequests]);

  const alertMessage = useMemo(() => {
    const { hasUnderwriting, hasTermSheet } = actionRequiredInfo;

    if (hasUnderwriting && hasTermSheet) {
      return "Action Required: You have outstanding underwriting conditions and a term sheet pending review. Please review your financing requests to address these items.";
    }
    if (hasUnderwriting) {
      return "Action Required: Your loan has outstanding underwriting conditions that need attention. Review your financing request to address these items and move forward.";
    }
    if (hasTermSheet) {
      return "Action Required: You have a term sheet pending review. Please review the terms and accept or reject to proceed with your financing request.";
    }
    return "";
  }, [actionRequiredInfo]);

  return (
    <Flx column>
      <DismissibleAlert
        show={actionRequiredInfo.show && show}
        severity="error"
        onClose={() => setShowDetails(false)}
        sx={{
          flexWrap: "wrap",
          borderBottomRightRadius: showDetails ? 0 : "4px",
          borderBottomLeftRadius: showDetails ? 0 : "4px",
        }}
        action={
          <Flx g={1}>
            <Button
              onClick={() => setShowDetails(!showDetails)}
              color="inherit"
              // sx={{ borderColor: "#232a31", color: "#232a31" }}
              startIcon={
                showDetails ? (
                  <KeyboardArrowUp fontSize="small" />
                ) : (
                  <KeyboardArrowDown fontSize="small" />
                )
              }
              variant="outlined"
              size="small"
            >
              {showDetails ? "Hide Details" : "View Details"}
            </Button>
            {/* <Button
              onClick={() => setShow(false)}
              color="error"
              variant="outlined"
              size="small"
            >
              Dismiss
            </Button> */}
          </Flx>
        }
        icon={<NotificationImportant className="thin" fontSize="inherit" />}
        // fontSize="14px"
        // alertId="action-required"
        // hideDuration={24} // Hide for 24 hours after dismiss
      >
        {alertMessage}
      </DismissibleAlert>
      {showDetails && <ActiveFinancingRequestsConditionsSection />}
    </Flx>
  );
};

export default ActionRequiredAlert;
